import React from 'react';
import { useEffect, useState } from 'react';
import { Grid, Typography, Button } from '@mui/material';
import imgurl from './assests/images/imgurl';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { useSelector, useDispatch } from 'react-redux'
import { replace, useNavigate } from "react-router-dom";
import { setactiveview } from './Reducers/reducer';



function TakePhotoBack({ capture }) {
  const navigate = useNavigate();
  const dispatch = useDispatch()

  const Backview = useSelector((state) => state.user.profile.Backview);

  useEffect(() => {
    if (Backview) {
      console.log("User name changed:", Backview);
    }
  }, [Backview]); // Runs when "name" changes

  function enablecamera() {
    navigate('/headcapture')
    dispatch(setactiveview('Back'))
  }

  return (
    <div className="photo-container main-section-container take-photoSection">
      <Grid container spacing={0} className='d-flex justify-content-start align-items-center'>
        <Grid item xs={1} className=''>
          <div className='d-flex justify-content-start align-items-center'>

            <span className='backButtonDiv' onClick={() => navigate('/taketest')}>
              <ArrowBackOutlinedIcon className='arrowBackBtn'></ArrowBackOutlinedIcon>
            </span>
          </div>
        </Grid>
        <Grid item xs={11} className='d-flex justify-content-center align-items-center'>
          <Typography variant="h6" className="title">Take a Test - Self Scan</Typography>
        </Grid>

      </Grid>
      <Grid container spacing={0} className='d-flex align-items-center justify-content-center flex-direction-column mt-5px'>
        <Grid item xs={12} className='d-flex justify-content-center align-items-center flex-direction-column'>
          <div className='backPhotoImg'></div>
          {/* <p className='mainHeading'>Back</p> */}
          <Typography variant="h6" className='subHeading'>Move the phone to the back of your head for a clear
          back view.</Typography>
          <Button variant="contained" className='commonButton mt-20px d-flex justify-content-center align-items-center gap-10px' onClick={() => capture('capture', 'tutorial')}>
            <CameraAltOutlinedIcon></CameraAltOutlinedIcon>
            Take <span>a</span>  Photo</Button>
          {/* <Button variant="contained" className='commonButton d-flex justify-content-center align-items-center gap-10px' onClick={() => capture('upload', 'tutorial')}>
            <CloudUploadOutlinedIcon></CloudUploadOutlinedIcon>
            Upload<span>from</span>Gallery</Button> */}
        </Grid>
      </Grid>

    </div>
  )
}

export default TakePhotoBack